<template>
  <div class="container">
    <div class="custom-group-tours-reviews py-80 mb-py-20">
      <div class="introduction flex mb-38 mb-mb-24">
        <div class="text wp-100">
          <template v-if="!loading">
            <h2 class="fs-40 mb-fs-32 fw-700 mb-fs-32 lh-52 mb-lh-42 ls-1">
              {{ REVIEWS_HEADER }}
            </h2>
            <p class="fs-16 fw-500 lh-22 ls-1 mb-0">
              {{ REVIEWS_SUBHEADER }}
            </p>
          </template>
          <template v-else>
            <SkeletonLoading
              class="mb-8"
              :width="windowWidth >= TABLET ? '50%' : '100%'"
              :height="windowWidth >= TABLET ? '40px' : '24px'"
            />
            <SkeletonLoading
              class="mb-4"
              :width="'100%'"
              :height="windowWidth >= TABLET ? '24px' : '16px'"
            />
            <SkeletonLoading
              :width="'30%'"
              :height="windowWidth >= TABLET ? '24px' : '16px'"
            />
          </template>
        </div>
        <div
          v-if="windowWidth >= TABLET"
          class="introduction-reviews minw-250 tl-dn relative"
        >
          <template v-if="!loading">
            <img
              class="w-60 mb-w-40 absolute text-icon"
              :src="`${ASSETS_CDN}/icons/sketch_annotation.svg`"
              alt="text-icon"
            />
            <p class="fw-600 fs-16 lh-24 ls-1 mb-8">
              {{ REVIEWS_NOTE }}
            </p>
            <div
              class="introduction-reviews-list-avatar wp-100 flex justify-end"
            >
              <img
                v-for="item in 5"
                :key="item"
                :src="`${ASSETS_CDN}/images/customgrouptour/User_${`0${item}`}.png`"
                class="user-avatar w-56 br-p-50 ml--20 bd-green-dark bd-2"
                alt="user-avatar"
              />
            </div>
          </template>
          <template v-else>
            <SkeletonLoading
              class="mb-8"
              :width="'100%'"
              :height="windowWidth >= TABLET ? '24px' : '16px'"
            />
            <div
              class="introduction-reviews-list-avatar wp-100 flex justify-end"
            >
              <SkeletonLoading
                v-for="item in 5"
                :key="item"
                borderRadius="50%"
                width="52px"
                height="52px"
                class="user-avatar w-56 br-p-50 ml--20 bd-gray-scroll bd-2"
              />
            </div>
          </template>
        </div>
      </div>
      <div
        class="
          list-review-cards
          flex flex-nowrap
          grid-gap-20
          mb-grid-gap-8
          overflow-auto
          pb-20
        "
        v-drag-scroll
      >
        <template v-if="!loading">
          <CGTReviewsCard
            v-for="(item, index) in reviewsData.items"
            :country="item.country_name"
            :date="item.date"
            :content="item.content"
            :traveller-name="`${item.first_name} ${item.last_name}`"
            :traveller-type="item.user_type"
            :rating="item.rating"
            :key="index"
            :image="item.trip_banner.url"
            :link="item.link_review"
          />
        </template>
        <template v-else>
          <CGTReviewsCard v-for="item in 5" :key="item" :loading="true" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import CGTReviewsCard from '~/components/pages/LandingPage/CGTReviews/CGTReviewsCard.vue'
import {
  REVIEWS_HEADER,
  REVIEWS_SUBHEADER,
  REVIEWS_NOTE,
} from '~/constant/customGroupTours'
import { useDragScroll } from '~/helper/useDragScroll'
import {  TABLET } from '~/constant/common'
import { computed } from 'vue'
import SkeletonLoading from '~/components/globals/Loading/SkeletonLoading'
import { assetCDN } from '~/helper'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

const ASSETS_CDN = assetCDN()

// eslint-disable-next-line no-undef
defineProps({
  reviewsData: {
    type: Object,
    default: () => null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const { vDragScroll } = useDragScroll()

const generalStore = useGeneralInfoStore()

const windowWidth = computed(
  () => generalStore.generalData.windowWidth,
)
</script>

<style lang="scss" scoped>
.introduction-reviews {
  .text-icon {
    top: -30px;
    right: -35px;
    transform: rotate(90deg);
  }
}

.list-review-cards {
  &::-webkit-scrollbar {
    background: #fff;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: $gray-medium;
    border-radius: 100px;
  }

  @include tablet() {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
